import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'inputbar',
  templateUrl: './input-bar.component.html',
  styleUrls: ['./input-bar.component.scss']
})
export class InputBarComponent implements OnInit {

  public isFocused = false;

  @Output() input: EventEmitter<any> = new EventEmitter();
  @Output() submit: EventEmitter<any> = new EventEmitter();

  constructor() {

  }

  ngOnInit() {

  }

  public didInput() {
    this.input.emit(null);
  }

  public didSubmit(message: any) {
    this.submit.emit(message.value);
    message.value = '';
  }

  public doFocus() {
    this.isFocused = true;
  }

  public doBlur() {
    this.isFocused = false;
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/input-bar/input-bar.component.ts